import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
import Select from './filters/Select';

const Filters = () => {
	const { tax } = useFiltersContext();

	const taxEntries = Object.entries(tax);
	if (taxEntries.length) {
		return (
			<div className="pfa-filters">
				{taxEntries.map(([key, taxonomy]) => {
					return (
						<div className="pfa-filters__filter" key={key}>
							<div className="pfa-filters__title">{taxonomy.labels.singular}</div>
							<Select taxonomy={taxonomy} />
						</div>
					);
				})}
			</div>
		);
	}

	return <></>;
};

Filters.displayName = 'Filters';

export default Filters;
